import {Observable, Subscription} from "rxjs";
import {OnDestroy} from "@angular/core";

export abstract class AbstractObserver implements OnDestroy{
  protected subscriptions = new Subscription();

  public subscribeToObservable(observable:Observable<any>, cb){
    this.subscriptions.add(observable.subscribe(cb));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
